import type { Command } from '../../types/commands'
import { formatCommandOutput, colorize, formatHighlight, formatTechnology } from '../colorScheme'
import { dividers, decorations } from '../asciiArt'

export const skillsCommand: Command = {
  name: 'skills',
  description: 'Display technical skills and expertise',
  aliases: ['tech', 'stack'],
  category: 'info',
  execute: () => {
    const skillsText = `
${colorize('[████████████████████████████████████████████████████████]', 'cyan')}
${colorize('[          TECHNICAL SKILLS & EXPERTISE                  ]', 'brightCyan')}
${colorize('[████████████████████████████████████████████████████████]', 'cyan')}

┌─────────────────────────────────────────────────────────┐
│ 📁 > ${formatHighlight('cat /skills/languages.txt')}                          │
└─────────────────────────────────────────────────────────┘

${formatTechnology('Ruby on Rails')}    ${colorize('[████████████████████]', 'green')} ${colorize('100%', 'magenta')}  ${colorize('10+', 'magenta')} years
${formatTechnology('TypeScript')}       ${colorize('[████████████████░░░░]', 'brightGreen')}  ${colorize('80%', 'magenta')}  Expert
${formatTechnology('JavaScript')}       ${colorize('[████████████████░░░░]', 'brightGreen')}  ${colorize('80%', 'magenta')}  Expert
${formatTechnology('Go')}               ${colorize('[█████████████░░░░░░░]', 'yellow')}  ${colorize('65%', 'magenta')}  Production
${formatTechnology('Python')}           ${colorize('[███████████░░░░░░░░░]', 'yellow')}  ${colorize('55%', 'magenta')}  Advanced
${formatTechnology('SQL')}              ${colorize('[██████████████░░░░░░]', 'brightGreen')}  ${colorize('70%', 'magenta')}  Expert

${colorize(dividers.gradient, 'cyan')}

┌─────────────────────────────────────────────────────────┐
│ 📁 > ${formatHighlight('ls -la /expertise/')}                                  │
└─────────────────────────────────────────────────────────┘

${colorize('drwxr-xr-x', 'brightBlack')}  ${colorize('ai-development/', 'brightBlue')}
${decorations.branch} Large Language Models (Claude, GPT-4)
${decorations.branch} Multi-agent AI Systems
${decorations.branch} Prompt Engineering
${decorations.corner} AI-Powered Automation

${colorize('drwxr-xr-x', 'brightBlack')}  ${colorize('accessibility/', 'brightBlue')}
${decorations.branch} WCAG 2.1 AA/AAA Compliance
${decorations.branch} Assistive Technology
${decorations.branch} Universal Design Principles
${decorations.corner} Screen Reader Optimization

${colorize('drwxr-xr-x', 'brightBlack')}  ${colorize('voice-interfaces/', 'brightBlue')}
${decorations.branch} Voice-AI Development
${decorations.branch} Speech Recognition Integration
${decorations.corner} Natural Language Processing

${colorize('drwxr-xr-x', 'brightBlack')}  ${colorize('full-stack/', 'brightBlue')}
├─ React 19 + TypeScript
├─ Node.js + Express
├─ Ruby on Rails
├─ PostgreSQL + MongoDB
└─ REST + GraphQL APIs

${colorize('drwxr-xr-x', 'brightBlack')}  ${colorize('systems/', 'brightBlue')}
├─ CLI Tool Development
├─ Database Architecture
├─ Performance Optimization
└─ Enterprise-Scale Applications

┌─────────────────────────────────────────────────────────┐
│ 📁 > ${formatHighlight('cat /expertise/specializations.txt')}                 │
└─────────────────────────────────────────────────────────┘

╭─ 🎯 ${formatHighlight('CORE SPECIALIZATIONS')} ──────────────────────────────╮
│                                                         │
│  ${colorize('▸', 'brightCyan')} AI Architecture & Integration                        │
│  ${colorize('▸', 'brightCyan')} Accessibility-First Development                     │
│  ${colorize('▸', 'brightCyan')} Neurodivergent-Centered Design                      │
│  ${colorize('▸', 'brightCyan')} Transparent Technology Development                  │
│  ${colorize('▸', 'brightCyan')} Open-Source Tool Development                       │
╰─────────────────────────────────────────────────────────╯

${colorize('///////////////////////////////////////////////////////////', 'brightBlack')}
  >> Type ${formatHighlight('projects')} to see these skills in action
  >> Type ${formatHighlight('experience')} to see work history
${colorize('///////////////////////////////////////////////////////////', 'brightBlack')}
`

    // Apply automatic formatting for technology names
    const formattedText = formatCommandOutput(skillsText, {
      highlightTech: true,
      highlightNumbers: true,
      highlightDates: false,
      highlightPaths: false,
      highlightUrls: false,
    })

    return [
      {
        type: 'info',
        content: (
          <div dangerouslySetInnerHTML={{ __html: formattedText }} />
        ),
      },
    ]
  },
}
